import type { IconData } from '@stacksjs/iconify-core'

export const lifebuoyF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.268 16.41a10.05 10.05 0 0 1 0-12.721l4.318 4.318a4.03 4.03 0 0 0 0 4.085zm1.42 1.421l4.32-4.318a4.03 4.03 0 0 0 4.084 0l4.318 4.318a10.05 10.05 0 0 1-12.721 0zM16.41 2.268l-4.318 4.318a4.03 4.03 0 0 0-4.085 0L3.69 2.268a10.05 10.05 0 0 1 12.72 0m1.421 1.42a10.05 10.05 0 0 1 0 12.722l-4.318-4.318a4.03 4.03 0 0 0 0-4.085L17.83 3.69z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default lifebuoyF
